import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setChameleonNavigationHandler } from '../../lib/chameleon';

/**
 * Makes Chameleon tour navigation use SPA routing. The app's CSP blocks
 * `unsafe-eval`, so tours cannot run custom JS; their built-in "navigate to
 * URL" action emits `app:navigate`, which this hook forwards to react-router.
 */
export const ChameleonNavHook = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setChameleonNavigationHandler(navigate);
  }, [navigate]);

  return null;
};
